<template>
  <modal
    name="all-preview-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
    @opened="
      setPreviewScale()
      previewLoading = false
    "
  >
    <div class="v--modal-close-top">
      <el-button
        @click="closeAllPreviewDialog"
        icon="el-icon-close"
        type="text"
      ></el-button>
    </div>
    <div class="backup-preview-dialog">
      <div class="formats-info">
        <div class="title">
          <p>プレビュー</p>
        </div>
      </div>
      <el-tabs
        v-model="activePreviewTab"
        class="backup-tabs"
        :stretch="true"
        @tab-click="
          setPreviewScale()
          previewLoading = false
        "
      >
        <el-tab-pane
          label="送付先情報を入力"
          name="basic_send_data"
          :lazy="true"
          :style="backupDataViewerCssRirekisho"
        >
          入力フォーム
        </el-tab-pane>
        <el-tab-pane
          label="履歴書"
          name="format_rirekisho"
          :lazy="true"
          :style="backupDataViewerCssRirekisho"
        >
          <rirekisho-preview
            ref="backupDataViewer"
            :id-prefix="'backup'"
            :format-data="formatData.format_rirekisho"
            :basic-data="formatData.basicData"
            :preview-scale="previewScale"
          ></rirekisho-preview>
        </el-tab-pane>
        <el-tab-pane
          label="職務経歴書"
          name="format_shokumukeirekisho"
          :lazy="true"
          :style="backupDataViewerCssShokurekisho"
        >
          <shokurekisho-preview
            ref="backupDataViewer"
            :id-prefix="'backup'"
            :format-data="formatData.format_shokumukeirekisho"
            :basic-data="formatData.basicData"
            :preview-scale="previewScale"
          ></shokurekisho-preview>
        </el-tab-pane>
        <el-tab-pane
          label="送付状"
          name="format_letter"
          :lazy="true"
          :style="backupDataViewerCssRirekisho"
        >
          <letter-preview
            ref="backupDataViewer"
            :id-prefix="'backup'"
            :format-data="formatData.format_letter"
            :basic-data="formatData.basicData"
            :preview-scale="previewScale"
          ></letter-preview>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="text-right">
      <el-button type="primary" @click="closeAllPreviewDialog"
        >決済情報を入力する</el-button
      >
      <el-button @click="closeAllPreviewDialog">閉じる</el-button>
    </div>
    <br /><br />
  </modal>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
import { TabPane, Tabs } from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'basicData',
  'recentEdit'
]
export default {
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'letter-preview': LetterPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane
  },
  data: function () {
    return {
      formatData: {},
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      previewScale: 1,
      previewLoading: false,
      activeTabName: 'user',
      activePreviewTab: 'basic_send_data'
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(
      function (value, key, iterationNumber) {
        app.formatData[key] = value
      },
      function (err) {
        if (err) {
          console.error(err)
        }
      }
    )
  },
  computed: {
    cleanedPreviewHtml: function () {
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      return formData
    }
  },
  methods: {
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
          this.previewScale =
            clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          console.log(clientWidth, this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height =
        this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect()
          .height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
      } else if (
        this.activePreviewTab === 'format_shokumukeirekisho' &&
        height > 0
      ) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      } else if (this.activePreviewTab === 'format_letter' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      }
    },
    openAllPreviewDialog: function (id, html) {
      const app = this
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      console.error(this.formatData)
      const storageData = {}
      this.$iterateStorage(
        function (value, key, iterationNumber) {
          app.formatData[key] = value
        },
        function (err) {
          if (err) {
            console.error(err)
          }
        }
      )
      this.$modal.show('all-preview-dialog')
    },
    closeAllPreviewDialog: function () {
      this.$modal.hide('all-preview-dialog')
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-all-preview-dialog', this.openAllPreviewDialog)
    this.$eventHub.$on('popstate', this.closeAllPreviewDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-all-preview-dialog', this.openAllPreviewDialog)
    this.$eventHub.$off('popstate', this.closeAllPreviewDialog)
  }
}
</script>
